import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useRef, useState, useMemo } from "react";
import { Popover } from "@mui/material";
import { MenuItem } from "../../../../../components/menu-item/menu-item.js";
import StyledTooltip from "../../../../../components/styled-tooltip/styled-tooltip.js";
import { useLabels } from "../../labels.provider.js";
import { Root, RoomName, StyledKeyboardArrowUp, StyledKeyboardArrowDown, OptionsContainer } from "./room-select.styles.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "@mui/icons-material";
const RoomSelect = ({ value, options, onSelect }) => {
  const { labels } = useLabels();
  const anchorRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const selectedRoom = useMemo(() => {
    if (!value)
      return void 0;
    return options.find(({ referenceId }) => referenceId === value);
  }, [options, value]);
  const handleOpenChange = (newValue) => () => {
    setIsOpen((prev) => newValue ?? !prev);
  };
  const handleRoomSelect = (roomReferenceId) => () => {
    if (value !== roomReferenceId) {
      onSelect(roomReferenceId);
    }
    handleOpenChange(false)();
  };
  const roomName = selectedRoom == null ? void 0 : selectedRoom.name;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(StyledTooltip, { disableHoverListener: !roomName, title: roomName, children: /* @__PURE__ */ jsxs(Root, { ref: anchorRef, onClick: handleOpenChange(), children: [
      /* @__PURE__ */ jsx(RoomName, { variant: "Lato Caption Bold", noWrap: true, children: roomName ?? labels.room }),
      isOpen && /* @__PURE__ */ jsx(StyledKeyboardArrowUp, {}),
      !isOpen && /* @__PURE__ */ jsx(StyledKeyboardArrowDown, {})
    ] }) }),
    /* @__PURE__ */ jsx(
      Popover,
      {
        open: isOpen,
        anchorEl: anchorRef.current,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        onClose: handleOpenChange(false),
        children: /* @__PURE__ */ jsx(OptionsContainer, { children: options.map((room) => /* @__PURE__ */ jsx(
          MenuItem,
          {
            selected: value === room.referenceId,
            value: room.referenceId,
            size: "xs",
            onClick: handleRoomSelect(room.referenceId),
            children: room.name
          },
          room.referenceId
        )) })
      }
    )
  ] });
};
export {
  RoomSelect as default
};
